import { TypedDocumentNode } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { ProviderDepartmentAppointmentCountsQueryDocument } from '@docpace/manager-graphql/dist/urql.types'
import { ProviderDepartmentAppointmentCountsQueryResultFragment, ProviderDepartmentAppointmentCountsQueryParams } from '@docpace/manager-graphql'

const typedProviderDepartmentAppointmentCountsQueryDocument = ProviderDepartmentAppointmentCountsQueryDocument as TypedDocumentNode<ProviderDepartmentAppointmentCountsQueryResultFragment, Partial<ProviderDepartmentAppointmentCountsQueryParams>>

export function useProviderDepartmentAppointmentCountsQuery(opts?: useQuery.Options<ProviderDepartmentAppointmentCountsQueryResultFragment, Partial<ProviderDepartmentAppointmentCountsQueryParams>>){
    return useQuery(typedProviderDepartmentAppointmentCountsQueryDocument, opts)
}
